module.exports = __webpack_public_path__ + "prod/1.42.2/img/cpys_five.14db2133.png";